export default __webpack_public_path__ + "static/media/intelbras-brand.ddc4e65d.svg";